import {FormGroup} from '@angular/forms';
import {Component, forwardRef, Inject, Input} from '@angular/core';
import {FilterFieldAbstract} from './filter-field.abstract';
import {FilterDirective} from './container/filter.directive';

@Component({
    selector: 'tfl-filter-field-date-range-picker',
    template: `
        <div [formGroup]="formGroup" 
             [ngClass]="getFormGroupClasses()">
            
            <label [for]="id" 
                   [ngClass]="getFormLabelClasses()">
                {{ label | translate }}:
            </label>

            <div [ngClass]="getFormControlClasses()">
                <tfl-daterangepicker [id]="id"
                                     [name]="id"
                                     [beginPropName]="beginPropName"
                                     [endPropName]="endPropName"
                                     [formControlName]="controlName">
                </tfl-daterangepicker>
            </div>
        </div>
    `
})
export class FilterFieldDaterangepickerComponent extends FilterFieldAbstract {

    @Input('id') id: string;
    @Input('label') label: string;
    @Input('beginPropName') beginPropName: string = 'beginDate';
    @Input('endPropName') endPropName: string = 'endDate';

    @Input('formGroup') formGroup: FormGroup;
    @Input('controlName') controlName: string;
    @Input('defValue') defValue: any;

    protected filter: FilterDirective;

    constructor(@Inject(forwardRef(() => FilterDirective)) filter: FilterDirective) {
        super();
        this.filter = filter;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field-daterangepicker.component.ts